import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3366030061/src/github.com/bitstone/offerz-nextjs/src/app/[lang]/(main)/_components/home-component.tsx");
